module.exports = __webpack_public_path__ + "img/ie.58d927c4.jpg";